import { useContext } from "react";
import { CorrectionFormContext } from "./context";

export const useCorrectionForm = () => {
  const context = useContext(CorrectionFormContext);
  if (context === undefined) {
    throw new Error(
      "useCorrectionForm must be used within a CorrectionFormProvider",
    );
  }
  return context;
};
